import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { ROUTER_NAVIGATED } from '@ngrx/router-store'
import { Store } from '@ngrx/store'
import {
  filter,
  map,
  withLatestFrom,
} from 'rxjs/operators'
import { AAAStore } from '../../store/root-reducer'
import { ConfigService } from '../config/config.service'
import { selectMembershipNumber } from '../member/member.selectors'
import { selectUserSessionId } from '../session/session.selectors'
import {
  NOTIFY_HOTJAR_ACTION,
  notifyHotjarAction,
} from './tagging.actions'
import {
  HotjarFunction,
  HotjarHitTypes,
  HotjarParams,
  HotjarPayload,
} from './tagging.types'
import { getHotjar, HOTJAR_RECORD_EVENT_LIST } from './tagging.utils'

@Injectable()
export class TaggingEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<AAAStore>,
    private configService: ConfigService,
  ) {}

  handleHotjarSessionId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        withLatestFrom(
          this.store$.select(selectUserSessionId),
          this.store$.select(selectMembershipNumber)
        ),
        map(([_, eventActionOrSessionId, membershipNumber], index) => {
          const isFirstNavigation = index === 0

          const payload = {
            eventActionOrSessionId,
            hitType: HotjarHitTypes.IDENTIFY,
            membershipNumber
          }

          if (isFirstNavigation) {
            this.transmitHotjarEvent(payload)
          }
        })),
    { dispatch: false }
  )

  handleHotjarAction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NOTIFY_HOTJAR_ACTION),
        filter(
          (action: ReturnType<typeof notifyHotjarAction>) =>
            HOTJAR_RECORD_EVENT_LIST.includes(action.payload)
          || action.payload.includes('variation')
        ),
        map((action) => this.transmitHotjarEvent({ eventActionOrSessionId: action.payload }))
      ),
    { dispatch: false }
  )

  transmitHotjarEvent(params: HotjarParams): void {
    const payload: HotjarPayload = [
      params.hitType = params.hitType ?? HotjarHitTypes.EVENT,
      params.eventActionOrSessionId
    ]

    if (params.membershipNumber) {
      payload.push({ membershipNumber: params.membershipNumber })
    }

    getHotjar()
      .then((hj: HotjarFunction) => {
        hj(...payload)
        if (this.configService.getConfig().configTools) {
          console.log(`Hotjar: ${params.hitType} - ${params.eventActionOrSessionId}`)
        }
      })
      .catch((err) => {
        if (this.configService.getConfig().configTools) {
          console.warn('Hotjar is not defined within 3 seconds.', err)
        }
      })
  }
}

